var MusicBliss = {};

MusicBliss.ShippingEstimator = (function() {
  var seaRate = {
    sabah : [
    	{lowerLimit: 14000, upperLimit: 100000, fee: "180.00"},
      	{lowerLimit: 100000, upperLimit: 200000, fee: "360.00"}
  	],
    sarawak : [
      	{lowerLimit: 14000, upperLimit: 100000, fee: "180.00"},
      	{lowerLimit: 100000, upperLimit: 200000, fee: "360.00"}
  	],
    labuan : [
    	{lowerLimit: 14000, upperLimit: 100000, fee: "180.00"},
      	{lowerLimit: 100000, upperLimit: 200000, fee: "360.00"}
  	],
  };

  var posLajuRate = {
    westMalaysia : [
      {lowerLimit: 0, upperLimit: 500, fee: "6.00"},
      {lowerLimit: 500, upperLimit: 532, fee: "6.00"},
      {lowerLimit: 532, upperLimit: 533, fee: "0.00"},
      {lowerLimit: 533, upperLimit: 700, fee: "6.00"},
      {lowerLimit: 700, upperLimit: 1000, fee: "6.00"},
      {lowerLimit: 1000, upperLimit: 1532, fee: "11.00"},
      {lowerLimit: 1532, upperLimit: 1533, fee: "0.00"},
      {lowerLimit: 1533, upperLimit: 2532, fee: "11.00"},
      {lowerLimit: 2532, upperLimit: 2533, fee: "0.00"},
      {lowerLimit: 2533, upperLimit: 3532, fee: "13.00"},   
      {lowerLimit: 3532, upperLimit: 3533, fee: "0.00"},
      {lowerLimit: 3533, upperLimit: 4000, fee: "13.00"},   
      {lowerLimit: 4000, upperLimit: 4532, fee: "15.00"},   
      {lowerLimit: 4532, upperLimit: 4533, fee: "0.00"},
      {lowerLimit: 4533, upperLimit: 5000, fee: "15.00"},
      {lowerLimit: 5000, upperLimit: 5532, fee: "15.00"},
      {lowerLimit: 5532, upperLimit: 5533, fee: "0.00"},
      {lowerLimit: 5533, upperLimit: 6532, fee: "15.00"},
      {lowerLimit: 6532, upperLimit: 6533, fee: "0.00"},
      {lowerLimit: 6533, upperLimit: 7532, fee: "15.00"},      
      {lowerLimit: 7532, upperLimit: 7533, fee: "0.00"},
      {lowerLimit: 7533, upperLimit: 8532, fee: "15.00"},
      {lowerLimit: 8532, upperLimit: 8533, fee: "0.00"},
      {lowerLimit: 8533, upperLimit: 9532, fee: "15.00"},
      {lowerLimit: 9532, upperLimit: 9533, fee: "0.00"},
      {lowerLimit: 9533, upperLimit: 10532, fee: "15.00"},
      {lowerLimit: 10532, upperLimit: 10533, fee: "0.00"},
      {lowerLimit: 10533, upperLimit: 11000, fee: "16.00"},
      {lowerLimit: 11000, upperLimit: 11532, fee: "18.00"},
      {lowerLimit: 11532, upperLimit: 11533, fee: "0.00"}, 
      {lowerLimit: 11533, upperLimit: 12000, fee: "18.00"},
      {lowerLimit: 12000, upperLimit: 12532, fee: "19.00"},
      {lowerLimit: 12532, upperLimit: 12533, fee: "0.00"},
      {lowerLimit: 12533, upperLimit: 13000, fee: "19.00"},
      {lowerLimit: 13000, upperLimit: 13532, fee: "21.00"},
      {lowerLimit: 13532, upperLimit: 13533, fee: "0.00"},
      {lowerLimit: 13533, upperLimit: 14000, fee: "21.00"},
      {lowerLimit: 14000, upperLimit: 14532, fee: "22.00"},
      {lowerLimit: 14532, upperLimit: 14533, fee: "0.00"},
      {lowerLimit: 14533, upperLimit: 15000, fee: "22.00"},
      {lowerLimit: 15000, upperLimit: 15532, fee: "24.00"},
      {lowerLimit: 15532, upperLimit: 15533, fee: "0.00"},
      {lowerLimit: 15533, upperLimit: 16000, fee: "24.00"},
      {lowerLimit: 16000, upperLimit: 16532, fee: "25.00"},
      {lowerLimit: 16532, upperLimit: 16533, fee: "0.00"},
      {lowerLimit: 16533, upperLimit: 17000, fee: "25.00"},
      {lowerLimit: 17000, upperLimit: 17532, fee: "26.00"},
      {lowerLimit: 17532, upperLimit: 17533, fee: "0.00"},
      {lowerLimit: 17533, upperLimit: 18000, fee: "26.00"},
      {lowerLimit: 18000, upperLimit: 18532, fee: "28.00"},
      {lowerLimit: 18532, upperLimit: 18533, fee: "0.00"},
      {lowerLimit: 18533, upperLimit: 19000, fee: "28.00"},
      {lowerLimit: 19000, upperLimit: 19532, fee: "29.00"},
      {lowerLimit: 19532, upperLimit: 19533, fee: "0.00"},
      {lowerLimit: 19533, upperLimit: 20000, fee: "29.00"},
      {lowerLimit: 20000, upperLimit: 20532, fee: "31.00"},
      {lowerLimit: 20532, upperLimit: 20533, fee: "0.00"},
      {lowerLimit: 20533, upperLimit: 21000, fee: "31.00"},
      {lowerLimit: 21000, upperLimit: 21532, fee: "32.00"},
      {lowerLimit: 21532, upperLimit: 21533, fee: "0.00"},
      {lowerLimit: 21533, upperLimit: 22000, fee: "32.00"},
      {lowerLimit: 22000, upperLimit: 22532, fee: "34.00"},      
      {lowerLimit: 22532, upperLimit: 22533, fee: "0.00"},
      {lowerLimit: 22533, upperLimit: 23000, fee: "34.00"},
      {lowerLimit: 23000, upperLimit: 23532, fee: "35.00"},    
      {lowerLimit: 23532, upperLimit: 23533, fee: "0.00"},
      {lowerLimit: 23533, upperLimit: 24000, fee: "35.00"},
      {lowerLimit: 24000, upperLimit: 24532, fee: "37.00"},
      {lowerLimit: 24532, upperLimit: 24533, fee: "0.00"},
      {lowerLimit: 24533, upperLimit: 25000, fee: "37.00"},
      {lowerLimit: 25000, upperLimit: 25532, fee: "38.00"},      
      {lowerLimit: 25532, upperLimit: 25533, fee: "0.00"},
      {lowerLimit: 25533, upperLimit: 26000, fee: "38.00"},            
      {lowerLimit: 26000, upperLimit: 26532, fee: "39.00"},
      {lowerLimit: 26532, upperLimit: 26533, fee: "0.00"},
      {lowerLimit: 26533, upperLimit: 27000, fee: "39.00"},
      {lowerLimit: 27000, upperLimit: 27532, fee: "41.00"},
      {lowerLimit: 27532, upperLimit: 27533, fee: "0.00"},   
      {lowerLimit: 27533, upperLimit: 28000, fee: "41.00"},
      {lowerLimit: 28000, upperLimit: 29000, fee: "42.00"},
      {lowerLimit: 29000, upperLimit: 30000, fee: "44.00"},
      {lowerLimit: 30000, upperLimit: 30532, fee: "45.00"},
      {lowerLimit: 30532, upperLimit: 30533, fee: "0.00"},
      {lowerLimit: 30533, upperLimit: 31000, fee: "45.00"},
      {lowerLimit: 31000, upperLimit: 32000, fee: "47.00"},
      {lowerLimit: 32000, upperLimit: 32532, fee: "48.00"},
      {lowerLimit: 32532, upperLimit: 32533, fee: "0.00"},
      {lowerLimit: 32533, upperLimit: 33532, fee: "48.00"},
      {lowerLimit: 33532, upperLimit: 33533, fee: "0.00"},
      {lowerLimit: 33533, upperLimit: 34000, fee: "50.00"},
      {lowerLimit: 34000, upperLimit: 34532, fee: "51.00"},
      {lowerLimit: 34532, upperLimit: 34533, fee: "0.00"},
      {lowerLimit: 34533, upperLimit: 35000, fee: "51.00"},
      {lowerLimit: 35000, upperLimit: 36000, fee: "52.00"},
      {lowerLimit: 36000, upperLimit: 36532, fee: "54.00"},   
      {lowerLimit: 36532, upperLimit: 36533, fee: "0.00"},
      {lowerLimit: 36533, upperLimit: 37000, fee: "54.00"},
      {lowerLimit: 37000, upperLimit: 37532, fee: "55.00"},    
       {lowerLimit: 37532, upperLimit: 37533, fee: "0.00"},
       {lowerLimit: 37533, upperLimit: 38032, fee: "55.00"},    
      {lowerLimit: 38033, upperLimit: 38034, fee: "0.00"}, 
      {lowerLimit: 38034, upperLimit: 38532, fee: "57.00"},
      {lowerLimit: 38532, upperLimit: 38533, fee: "0.00"},
      {lowerLimit: 38533, upperLimit: 39000, fee: "57.00"},
      {lowerLimit: 39000, upperLimit: 40000, fee: "58.00"},
      {lowerLimit: 40000, upperLimit: 40532, fee: "60.00"},  
      {lowerLimit: 40532, upperLimit: 40533, fee: "0.00"},
      {lowerLimit: 40533, upperLimit: 41000, fee: "60.00"},
      {lowerLimit: 41000, upperLimit: 42000, fee: "61.00"},
      {lowerLimit: 42000, upperLimit: 42532, fee: "62.00"},      
      {lowerLimit: 42532, upperLimit: 42533, fee: "0.00"},
      {lowerLimit: 42533, upperLimit: 43000, fee: "62.00"},   
      {lowerLimit: 43000, upperLimit: 43532, fee: "64.00"},
      {lowerLimit: 43532, upperLimit: 43533, fee: "0.00"},     
      {lowerLimit: 43533, upperLimit: 44000, fee: "64.00"},
      {lowerLimit: 44000, upperLimit: 44532, fee: "65.00"},     
       {lowerLimit: 44532, upperLimit: 44533, fee: "0.00"},
       {lowerLimit: 44533, upperLimit: 45000, fee: "65.00"}, 
      {lowerLimit: 45000, upperLimit: 45532, fee: "67.00"},
      {lowerLimit: 45532, upperLimit: 45533, fee: "0.00"},    
      {lowerLimit: 45533, upperLimit: 46000, fee: "67.00"},
      {lowerLimit: 46000, upperLimit: 47000, fee: "68.00"},
      {lowerLimit: 47000, upperLimit: 47532, fee: "70.00"},      
      {lowerLimit: 47532, upperLimit: 47533, fee: "0.00"},
      {lowerLimit: 47533, upperLimit: 48000, fee: "70.00"}, 
      {lowerLimit: 48000, upperLimit: 48532, fee: "71.00"},
      {lowerLimit: 48532, upperLimit: 48533, fee: "0.00"},    
      {lowerLimit: 48533, upperLimit: 49000, fee: "71.00"},
      {lowerLimit: 49000, upperLimit: 50000, fee: "73.00"},
      {lowerLimit: 50000, upperLimit: 50532, fee: "80.00"},
      {lowerLimit: 50532, upperLimit: 50533, fee: "0.00"},
      {lowerLimit: 50533, upperLimit: 51532, fee: "80.00"},
      {lowerLimit: 51532, upperLimit: 51533, fee: "0.00"},
      {lowerLimit: 51533, upperLimit: 52532, fee: "80.00"},
      {lowerLimit: 52532, upperLimit: 52533, fee: "0.00"},
      {lowerLimit: 52533, upperLimit: 55000, fee: "80.00"},
      {lowerLimit: 55000, upperLimit: 55532, fee: "87.00"},
      {lowerLimit: 55532, upperLimit: 55533, fee: "0.00"},
      {lowerLimit: 55533, upperLimit: 56532, fee: "87.00"},   
      {lowerLimit: 56532, upperLimit: 56533, fee: "0.00"},
      {lowerLimit: 56533, upperLimit: 58532, fee: "87.00"},          
      {lowerLimit: 58532, upperLimit: 58533, fee: "0.00"},   
      {lowerLimit: 58533, upperLimit: 59532, fee: "87.00"},               
      {lowerLimit: 59532, upperLimit: 59533, fee: "0.00"},  
      {lowerLimit: 59533, upperLimit: 60000, fee: "87.00"},   
      {lowerLimit: 60000, upperLimit: 60532, fee: "94.00"},
        {lowerLimit: 60532, upperLimit: 60533, fee: "0.00"},
        {lowerLimit: 60533, upperLimit: 61532, fee: "101.00"},     
      {lowerLimit: 61532, upperLimit: 61533, fee: "0.00"},
      {lowerLimit: 61533, upperLimit: 63532, fee: "101.00"},   
      {lowerLimit: 63532, upperLimit: 63533, fee: "0.00"},
      {lowerLimit: 63533, upperLimit: 65532, fee: "101.00"},      
      {lowerLimit: 65532, upperLimit: 65533, fee: "0.00"},
      {lowerLimit: 65533, upperLimit: 65732, fee: "101.00"},    
      {lowerLimit: 65732, upperLimit: 65733, fee: "0.00"},
      {lowerLimit: 65733, upperLimit: 70000, fee: "101.00"},
      {lowerLimit: 70000, upperLimit: 75000, fee: "109.00"},
      {lowerLimit: 75000, upperLimit: 79532, fee: "116.00"},      
      {lowerLimit: 79532, upperLimit: 79533, fee: "0.00"},
      {lowerLimit: 79533, upperLimit: 80000, fee: "116.00"},     
      {lowerLimit: 80000, upperLimit: 80532, fee: "123.00"},
      {lowerLimit: 80532, upperLimit: 80533, fee: "0.00"},
      {lowerLimit: 80533, upperLimit: 85000, fee: "123.00"},
      {lowerLimit: 85000, upperLimit: 90000, fee: "130.00"},
      {lowerLimit: 90000, upperLimit: 90532, fee: "137.00"},
      {lowerLimit: 90532, upperLimit: 90533, fee: "0.00"},
      {lowerLimit: 90533, upperLimit: 95000, fee: "137.00"},
      {lowerLimit: 95000, upperLimit: 95532, fee: "145.00"},     
      {lowerLimit: 95532, upperLimit: 95533, fee: "0.00"},
      {lowerLimit: 95533, upperLimit: 100000, fee: "145.00"},
       {lowerLimit: 100000, upperLimit: 101000, fee: "146"},
       {lowerLimit: 101000, upperLimit: 102000, fee: "148"},
       {lowerLimit: 102000, upperLimit: 103000, fee: "149"},
       {lowerLimit: 103000, upperLimit: 104000, fee: "150"},
       {lowerLimit: 104000, upperLimit: 105000, fee: "152"},
       {lowerLimit: 105000, upperLimit: 106000, fee: "153"},
       {lowerLimit: 106000, upperLimit: 107000, fee: "155"},
       {lowerLimit: 107000, upperLimit: 108000, fee: "156"},
       {lowerLimit: 108000, upperLimit: 109000, fee: "158"},
       {lowerLimit: 109000, upperLimit: 110000, fee: "159"},
       {lowerLimit: 110000, upperLimit: 111000, fee: "161"},
       {lowerLimit: 111000, upperLimit: 112000, fee: "162"},
       {lowerLimit: 112000, upperLimit: 113000, fee: "163"},
       {lowerLimit: 113000, upperLimit: 114000, fee: "165"},
       {lowerLimit: 114000, upperLimit: 115000, fee: "166"},
       {lowerLimit: 115000, upperLimit: 116000, fee: "168"},
       {lowerLimit: 116000, upperLimit: 117000, fee: "169"},
       {lowerLimit: 117000, upperLimit: 118000, fee: "171"},
       {lowerLimit: 118000, upperLimit: 119000, fee: "172"},
       {lowerLimit: 119000, upperLimit: 120000, fee: "173"},
       {lowerLimit: 120000, upperLimit: 121000, fee: "175"},
       {lowerLimit: 121000, upperLimit: 122000, fee: "176"},
       {lowerLimit: 122000, upperLimit: 123000, fee: "178"},
       {lowerLimit: 123000, upperLimit: 124000, fee: "179"},
       {lowerLimit: 124000, upperLimit: 125000, fee: "181"},
       {lowerLimit: 125000, upperLimit: 126000, fee: "182"},
       {lowerLimit: 126000, upperLimit: 127000, fee: "184"},
       {lowerLimit: 127000, upperLimit: 128000, fee: "185"},
       {lowerLimit: 128000, upperLimit: 129000, fee: "186"},
       {lowerLimit: 129000, upperLimit: 130000, fee: "188"},
       {lowerLimit: 130000, upperLimit: 131000, fee: "189"},
       {lowerLimit: 131000, upperLimit: 132000, fee: "191"},
       {lowerLimit: 132000, upperLimit: 133000, fee: "192"},
       {lowerLimit: 133000, upperLimit: 134000, fee: "194"},
       {lowerLimit: 134000, upperLimit: 135000, fee: "195"},
       {lowerLimit: 135000, upperLimit: 136000, fee: "197"},
       {lowerLimit: 136000, upperLimit: 137000, fee: "198"},
       {lowerLimit: 137000, upperLimit: 138000, fee: "199"},
       {lowerLimit: 138000, upperLimit: 139000, fee: "201"},
       {lowerLimit: 139000, upperLimit: 140000, fee: "202"},
       {lowerLimit: 140000, upperLimit: 141000, fee: "204"},
       {lowerLimit: 141000, upperLimit: 142000, fee: "205"},
       {lowerLimit: 142000, upperLimit: 143000, fee: "207"},
       {lowerLimit: 143000, upperLimit: 144000, fee: "208"},
       {lowerLimit: 144000, upperLimit: 145000, fee: "210"},
       {lowerLimit: 145000, upperLimit: 146000, fee: "211"},
       {lowerLimit: 146000, upperLimit: 147000, fee: "212"},
       {lowerLimit: 147000, upperLimit: 149000, fee: "215"},
       {lowerLimit: 149000, upperLimit: 150000, fee: "217"}


      
      
      
      
    ],
    sabah : [
     {lowerLimit: 0, upperLimit: 500, fee: "18.00"},
      {lowerLimit: 500, upperLimit: 700, fee: "18.00"},
      {lowerLimit: 700, upperLimit: 1000, fee: "18.00"},
      {lowerLimit: 1000, upperLimit: 1500, fee: "28.00"},
      {lowerLimit: 1500, upperLimit: 2000, fee: "28.00"},
      {lowerLimit: 2000, upperLimit: 2500, fee: "42.00"},
      {lowerLimit: 2500, upperLimit: 3000, fee: "42.00"},
      {lowerLimit: 3000, upperLimit: 3500, fee: "57.00"},
      {lowerLimit: 3500, upperLimit: 4000, fee: "57.00"},
      {lowerLimit: 4000, upperLimit: 4500, fee: "71.00"},
      {lowerLimit: 4500, upperLimit: 5000, fee: "71.00"},
      {lowerLimit: 5000, upperLimit: 5500, fee: "86.00"},
      {lowerLimit: 5500, upperLimit: 6000, fee: "86.00"},
      {lowerLimit: 6000, upperLimit: 6500, fee: "100.00"},
      {lowerLimit: 6500, upperLimit: 7000, fee: "100.00"},
      {lowerLimit: 7000, upperLimit: 7500, fee: "115.00"},
      {lowerLimit: 7500, upperLimit: 8000, fee: "115.00"},
      {lowerLimit: 8000, upperLimit: 8500, fee: "129.00"},
      {lowerLimit: 8500, upperLimit: 9000, fee: "129.00"},
      {lowerLimit: 9000, upperLimit: 9500, fee: "144.00"},
      {lowerLimit: 9500, upperLimit: 10000, fee: "144.00"},
      {lowerLimit: 10000, upperLimit: 11000, fee: "158.00"},
      {lowerLimit: 11000, upperLimit: 12000, fee: "172.00"},
      {lowerLimit: 12000, upperLimit: 13000, fee: "187.00"},
      {lowerLimit: 13000, upperLimit: 14000, fee: "201.00"}
    ],
    sarawak : [
      {lowerLimit: 0, upperLimit: 500, fee: "18.00"},
      {lowerLimit: 500, upperLimit: 700, fee: "18.00"},
      {lowerLimit: 700, upperLimit: 1000, fee: "18.00"},
      {lowerLimit: 1000, upperLimit: 1500, fee: "28.00"},
      {lowerLimit: 1500, upperLimit: 2000, fee: "28.00"},
      {lowerLimit: 2000, upperLimit: 2500, fee: "42.00"},
      {lowerLimit: 2500, upperLimit: 3000, fee: "42.00"},
      {lowerLimit: 3000, upperLimit: 3500, fee: "57.00"},
      {lowerLimit: 3500, upperLimit: 4000, fee: "57.00"},
      {lowerLimit: 4000, upperLimit: 4500, fee: "71.00"},
      {lowerLimit: 4500, upperLimit: 5000, fee: "71.00"},
      {lowerLimit: 5000, upperLimit: 5500, fee: "86.00"},
      {lowerLimit: 5500, upperLimit: 6000, fee: "86.00"},
      {lowerLimit: 6000, upperLimit: 6500, fee: "100.00"},
      {lowerLimit: 6500, upperLimit: 7000, fee: "100.00"},
      {lowerLimit: 7000, upperLimit: 7500, fee: "115.00"},
      {lowerLimit: 7500, upperLimit: 8000, fee: "115.00"},
      {lowerLimit: 8000, upperLimit: 8500, fee: "129.00"},
      {lowerLimit: 8500, upperLimit: 9000, fee: "129.00"},
      {lowerLimit: 9000, upperLimit: 9500, fee: "144.00"},
      {lowerLimit: 9500, upperLimit: 10000, fee: "144.00"},
      {lowerLimit: 10000, upperLimit: 11000, fee: "158.00"},
      {lowerLimit: 11000, upperLimit: 12000, fee: "172.00"},
      {lowerLimit: 12000, upperLimit: 13000, fee: "187.00"},
      {lowerLimit: 13000, upperLimit: 14000, fee: "201.00"}
    ],
    labuan : [
      {lowerLimit: 0, upperLimit: 500, fee: "18.00"},
      {lowerLimit: 500, upperLimit: 700, fee: "18.00"},
      {lowerLimit: 700, upperLimit: 1000, fee: "18.00"},
      {lowerLimit: 1000, upperLimit: 1500, fee: "28.00"},
      {lowerLimit: 1500, upperLimit: 2000, fee: "28.00"},
      {lowerLimit: 2000, upperLimit: 2500, fee: "42.00"},
      {lowerLimit: 2500, upperLimit: 3000, fee: "42.00"},
      {lowerLimit: 3000, upperLimit: 3500, fee: "57.00"},
      {lowerLimit: 3500, upperLimit: 4000, fee: "57.00"},
      {lowerLimit: 4000, upperLimit: 4500, fee: "71.00"},
      {lowerLimit: 4500, upperLimit: 5000, fee: "71.00"},
      {lowerLimit: 5000, upperLimit: 5500, fee: "86.00"},
      {lowerLimit: 5500, upperLimit: 6000, fee: "86.00"},
      {lowerLimit: 6000, upperLimit: 6500, fee: "100.00"},
      {lowerLimit: 6500, upperLimit: 7000, fee: "100.00"},
      {lowerLimit: 7000, upperLimit: 7500, fee: "115.00"},
      {lowerLimit: 7500, upperLimit: 8000, fee: "115.00"},
      {lowerLimit: 8000, upperLimit: 8500, fee: "129.00"},
      {lowerLimit: 8500, upperLimit: 9000, fee: "129.00"},
      {lowerLimit: 9000, upperLimit: 9500, fee: "144.00"},
      {lowerLimit: 9500, upperLimit: 10000, fee: "144.00"},
      {lowerLimit: 10000, upperLimit: 11000, fee: "158.00"},
      {lowerLimit: 11000, upperLimit: 12000, fee: "172.00"},
      {lowerLimit: 12000, upperLimit: 13000, fee: "187.00"},
      {lowerLimit: 13000, upperLimit: 14000, fee: "201.00"}
    ]
  };

  var _getPosLajuFee = function(weight, location, valueOnly){
    var o = 'N/A';

    var rate = [];

    if( location == 'West Malaysia' ){
      rate = posLajuRate.westMalaysia;
    }else if( location == 'Sabah' ){
      rate = posLajuRate.sabah;
    }else if( location == 'Sarawak' ){
      rate = posLajuRate.sarawak;
    }else if( location == 'Labuan' ){
      rate = posLajuRate.labuan;
    }

    var i = 0;
    for(i = 0; i < rate.length; i++){
      if( weight > rate[i].lowerLimit && weight <= rate[i].upperLimit ){
        o = rate[i].fee;
        break;
      }
    }
    
    if( o == 'N/A' ){
      return o;
    }else if(valueOnly){
      return parseFloat(o);
    }else{
      return 'RM' + o;
    }
  };

  var _getSeaFee = function(weight, location, valueOnly){
    var o = 'N/A';

    var rate = [];

    if( location == 'Sabah' ){
      rate = seaRate.sabah;
    }else if( location == 'Sarawak' ){
      rate = seaRate.sarawak;
    }else if( location == 'Labuan' ){
      rate = seaRate.labuan;
    }

    var i = 0;
    for(i = 0; i < rate.length; i++){
      if( weight >= rate[i].lowerLimit && weight <= rate[i].upperLimit ){
        o = rate[i].fee;
        break;
      }
    }
    
    if( o == 'N/A' ){
      return o;
    }else if(valueOnly){
      return parseFloat(o);
    }else{
      return 'RM' + o;
    }
  };

  return {
    getPosLajuFee: function(weight, location, valueOnly) {
      return _getPosLajuFee(weight, location, valueOnly);
    },
    getSeaFee: function(weight, location, valueOnly) {
      return _getSeaFee(weight, location, valueOnly);
    },
    getLowest: function(weight){
   	   var lowest = _getPosLajuFee(weight, 'West Malaysia', true);
       var a = _getPosLajuFee(weight, 'Sabah', true);
       var b = _getPosLajuFee(weight, 'Sarawak', true);
       var c = _getPosLajuFee(weight, 'Labuan', true);
      
       var d = _getSeaFee(weight, 'Sabah', true);
       var e = _getSeaFee(weight, 'Sarawak', true);
       var f = _getSeaFee(weight, 'Labuan', true);
       
      if( a < lowest ){
        lowest = a;
      }
      
      if( b < lowest ){
        lowest = b;
      }
      
      if( c < lowest ){
        lowest = c;
      }
      
      if( d < lowest ){
        lowest = d;
      }
      
      if( e < lowest ){
        lowest = e;
      }
      
      if( f < lowest ){
        lowest = f;
      }
   
    	return 'RM' + lowest;
   
       }
  }
})();

$(function(){
 var weight = $('#mb-shipping-estimate').data('weight');
 
 $('#mb-shipping-estimate .lowest').text('from as low as ' + MusicBliss.ShippingEstimator.getLowest(weight));
 $('#mb-poslaju-fee-wm').text(MusicBliss.ShippingEstimator.getPosLajuFee(weight, 'West Malaysia', false));
 $('#mb-poslaju-fee-sabah').text(MusicBliss.ShippingEstimator.getPosLajuFee(weight, 'Sabah', false));
 $('#mb-poslaju-fee-sarawak').text(MusicBliss.ShippingEstimator.getPosLajuFee(weight, 'Sarawak', false));
 $('#mb-poslaju-fee-labuan').text(MusicBliss.ShippingEstimator.getPosLajuFee(weight, 'Labuan', false));

 $('#mb-sea-fee-sabah').text(MusicBliss.ShippingEstimator.getSeaFee(weight, 'Sabah', false));
 $('#mb-sea-fee-sarawak').text(MusicBliss.ShippingEstimator.getSeaFee(weight, 'Sarawak', false));
 $('#mb-sea-fee-labuan').text(MusicBliss.ShippingEstimator.getSeaFee(weight, 'Labuan', false));
  
 $('#mb-shipping-estimate .mb-btn-toggle').on('click', function(e){
    e.preventDefault();
    var $target = $('#mb-shipping-estimate .mb-shipping-row');
    if( $target.hasClass('mb-toggle-show') ){
      $target.hide().removeClass('mb-toggle-show');
    }else{
      $target.show().addClass('mb-toggle-show');
    }
 });

/* Shon disable Read More function
 $('.collection-description').after('<a class="description-readmore" href="">Read more...</a>');
 $('.collection-description p:first').nextAll().hide();

 $('a.description-readmore').on('click', function(e){
   e.preventDefault();
   var $first = $('.collection-description p:first');

   if( $(this).hasClass('description-readless') ){
     $first.nextAll().hide();
     $(this).removeClass('description-readless').text('Read more...');
   }else{
     $first.nextAll().show();
     $(this).addClass('description-readless').text('Read less...');
   }
 });
*/
  $('.site-navigation .navmenu-id-shop-by-categories > a').on('click', function(e){
    if( $('.site-header-menu-toggle').css('visibility') == 'visible' ){
    	e.preventDefault();
   		$('.site-header-menu-toggle--button').trigger('click');
      	$('#site-mobile-nav .navmenu-id-shop-by-category > a').trigger('click');
  	}
  });
  
  $('.site-navigation .navmenu-id-shop-by-brands > a').on('click', function(e){
    if( $('.site-header-menu-toggle').css('visibility') == 'visible' ){
    	e.preventDefault();
   		$('.site-header-menu-toggle--button').trigger('click');
      	$('#site-mobile-nav .navmenu-id-shop-by-brand > a').trigger('click');
  	}
  });
});
